import { flowRight } from 'lodash/fp';
import PropTypes from 'prop-types';
import React from 'react';
import { formValues } from 'redux-form';
import FormGroup from 'components/form/Group';
import Title from 'components/Title';
import FormButtons from 'components/FormButtons';
import Divider from 'components/Divider';
import { SelectField } from 'components/form/field';
import simulationLoader from 'components/simulation/simulationLoader';
import ProgramForm from '../../common/property/ProgramForm';
import PropertyForm from '../../common/property/PropertyForm';
import dataForm from '../dataForm';
import Form from '../Form';
import SimulationHeader from '../Header';
import OperationForm from './OperationForm';

const taxRegime = (
    <SelectField
        name="taxRegime"
        title="Régime fiscal du bien"
        required
    >
        <option value="privateRentalNew">Statut Bailleur Privé – Neuf</option>
    </SelectField>
);

const PropertyInner = ({ handleSubmit, params: { id, simulationId }, needFunding, taxRegimeValue }) => (
    <Form handleSubmit={handleSubmit} needFunding={needFunding}>
        <div className="simulation-form-inner">
            <div className="container">
                <SimulationHeader />
                <FormGroup>
                    <Title><b>Dispositif</b></Title>
                    <ProgramForm taxRegime={taxRegime} avecZoneC immeubleARenover={taxRegimeValue !== 'privateRentalNew'} />
                </FormGroup>
                <Divider />
                <FormGroup>
                    <Title><b>Le bien</b></Title>
                    <PropertyForm />
                </FormGroup>
                <Divider />
                <FormGroup>
                    <Title><b>L&apos;opération</b></Title>
                    <OperationForm />
                </FormGroup>
            </div>
        </div>
        <FormButtons
            back={`/rip/${id}/simulations/${simulationId}/resume`}
            list={`/rip/${id}/simulations/`}
        />
    </Form>
);

PropertyInner.defaultProps = {
    needFunding: false,
};

PropertyInner.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    params: PropTypes.shape({
        id: PropTypes.string.isRequired,
        simulationId: PropTypes.string.isRequired,
    }).isRequired,
    needFunding: PropTypes.bool,
    taxRegimeValue: PropTypes.string,
};

const Property = flowRight([
    simulationLoader,
    dataForm({
        form: 'simulation-property',
        id: ({ params: { simulationId } }) => simulationId,
        onSubmitSuccess: (result, _dispatch, {
            navigate,
            params: { id, simulationId },
        }) => navigate(`/rip/${id}/simulations/${simulationId}/${result.needFunding ? 'financement' : 'charges'}`),
        type: 'simulation',
    }),
    formValues({ taxRegimeValue: 'taxRegime', needFunding: 'needFunding' }),
])(PropertyInner);

export default Property;
